"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UPDATE_ITEMS_IN_CART = exports.UPDATE_CART_V2 = exports.UPDATE_CART = exports.TOP_SELLING_PRODUCTS = exports.RESET_RX_CART = exports.REMOVE_MULTIPLE_ITEMS_FROM_CART = exports.REMOVE_ITEM_FROM_CART = exports.MERGE_CART_DETAILS = exports.GET_COMMON_SERVICE_CART_DATA = exports.GET_CART_V2 = exports.GET_CART_MARKETING_BANNER = exports.GET_CART_DETAILS = exports.GET_CART = exports.FBT_ADD_TO_CART = exports.DELETE_PRODUCTS_V2 = exports.DELETE_PRODUCTS = exports.CREATE_RX_CART = exports.CART_PRODUCTS_RECOMMENDATION = exports.CART_OPERATION_DATA = exports.CART_FILLERS = exports.ASTER_ONLINE_ADD_TO_CART = exports.ADD_TO_CART_V2 = exports.ADD_TO_CART = exports.ADD_ITEMS_TO_CART = void 0;
const ADD_TO_CART = exports.ADD_TO_CART = 'addToCart';
const UPDATE_CART = exports.UPDATE_CART = 'updateCart';
const GET_CART = exports.GET_CART = 'getCart';
const TOP_SELLING_PRODUCTS = exports.TOP_SELLING_PRODUCTS = 'topSellingProducts';
const DELETE_PRODUCTS = exports.DELETE_PRODUCTS = 'deleteProducts';
const CART_PRODUCTS_RECOMMENDATION = exports.CART_PRODUCTS_RECOMMENDATION = 'cartProductsRecommendation';
const ADD_TO_CART_V2 = exports.ADD_TO_CART_V2 = 'addToCartV2';
const UPDATE_CART_V2 = exports.UPDATE_CART_V2 = 'updateCartV2';
const DELETE_PRODUCTS_V2 = exports.DELETE_PRODUCTS_V2 = 'deleteProductsV2';
const GET_CART_V2 = exports.GET_CART_V2 = 'getCartV2';
const CART_OPERATION_DATA = exports.CART_OPERATION_DATA = 'cartOperationData';
const FBT_ADD_TO_CART = exports.FBT_ADD_TO_CART = 'FBTAddToCart';
const CART_FILLERS = exports.CART_FILLERS = 'cartFillers';
const ASTER_ONLINE_ADD_TO_CART = exports.ASTER_ONLINE_ADD_TO_CART = 'asterOnlineAddToCart';
const GET_CART_MARKETING_BANNER = exports.GET_CART_MARKETING_BANNER = 'getCartMarketBanner';
const ADD_ITEMS_TO_CART = exports.ADD_ITEMS_TO_CART = 'addItemsToCart';
const UPDATE_ITEMS_IN_CART = exports.UPDATE_ITEMS_IN_CART = 'updateItemsInCart';
const REMOVE_ITEM_FROM_CART = exports.REMOVE_ITEM_FROM_CART = 'removeItemFromCart';
const REMOVE_MULTIPLE_ITEMS_FROM_CART = exports.REMOVE_MULTIPLE_ITEMS_FROM_CART = 'removeMultipleItemsFromCart';

/**
 * New Cart constants for Api which provides merge response of CartInfo and CartInfoDetail
 * **/

const GET_COMMON_SERVICE_CART_DATA = exports.GET_COMMON_SERVICE_CART_DATA = 'getCommonServiceCartData';
const GET_CART_DETAILS = exports.GET_CART_DETAILS = 'getCartDetails';
const CREATE_RX_CART = exports.CREATE_RX_CART = 'createRxCart';
const RESET_RX_CART = exports.RESET_RX_CART = 'resetRxCart';
const MERGE_CART_DETAILS = exports.MERGE_CART_DETAILS = 'mergeCartDetails';